import Request from './request';

async function fetch(data) {
    return Request('get', "api/examines", data);
}

async function fetchOne(id, data) {
    return Request('get', "api/examines/view-by-group-material?id=" + id, data);
}

async function examine(data) {
    return Request('patch', "api/examines/examine-by-material", data);
}

async function returnExamines(data) {
    return Request('get', "api/examines/return-examines", data);
}

async function returnExaminesMaterial(data) {
    return Request('get', "api/examines/return-examines-material", data);

}

export default {
    fetch,
    fetchOne,
    examine,
    returnExamines,
    returnExaminesMaterial,
};